import React from 'react';
import PropTypes from 'prop-types';
import { Img } from 'components/Material';
import {
  getWinSize,
  getMenuWidth,
  calculateWH,
} from '@/utils/common';
import './style/index.less';

/**
 * 素材卡片
 */
class PictureShow extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };

  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    let { filetype, data: { name, src, sense, status, type, scope }, ...otherField } = this.props;

    let maxWidth = 100;
    let maxHeight = 100;
    
    let materialColImgStyle = {height: maxHeight + "px"};

    if (filetype !== 'media') {// 播放列表素材不走
      maxWidth = getMenuWidth('materialMaxWidth');
      maxHeight = getMenuWidth('materialMaxHeight');;

      materialColImgStyle = {height: maxHeight + "px"};
    } else {

      materialColImgStyle = {height: maxHeight + "px", backgroundColor : "transparent"};
    }

    if (!sense) {
      sense = "100x100";
    }

    let sizeObj = calculateWH(sense.toLowerCase().split('x')[0].trim(), sense.toLowerCase().split('x')[1].trim(), maxWidth, maxHeight);
    let width = sizeObj.width;
    let height = sizeObj.height;

    return (
      <div className="material-col-img" title={name} style={materialColImgStyle} {...otherField}>
        { status && status === '0' ? null : <Img draggable={false} src={src} alt="" title={name} style={{ width: width + 'px', height: height + 'px' }} /> }
        { !scope && status && (type === '0' || type === '15' || type === '16' || type === '17' || type === '35' || type === 'playlist') ? (
          <div>
            { status === '0' ? (
              <div className="material-cover">
                <Img style={{ width: '32px', height: '32px' }} className="material-convert-rotation" src="assets/images/material/material-convert.gif" />
              </div>
            ) : null }
            { status === '2' ? (
              <div className="material-cover">
                <Img style={{ width: '80px', height: '80px', top: '-20px' }} src="assets/images/material/material-fail.png" />
                <div className="material-cover-text">{window.language['material.upload.failMsg']}</div>
              </div>
            ) : null }
          </div>
        ) : null }
      </div>
    );
  }
}

export default PictureShow;



// WEBPACK FOOTER //
// ./src/components/PictureShow/PictureShow.js